<template>
	<div class="list-manifesto-component">
		<div v-if="!searchingManifestos">
			<nav class="navbar navbar-light bg-light">
				<div class="form-inline">
					<input class="form-control form-control-sm mr-sm-1" type="date" v-model="fromDateManifestos" @change="getAllManifestosLocal(1)">
					<input class="form-control form-control-sm mr-sm-1" type="date" v-model="toDateManifestos" @change="getAllManifestosLocal(1)">
					<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllManifestosLocal(1)" ref="btnGetManifestos">Buscar</button>
				</div>
				<div class="form-inline">
					<span class="mr-sm-1">Mostrar</span>
					<select class="form-control form-control-sm mr-sm-1 float-sm-right" id="qrows" v-model="qRowsManifesto" @change="getAllManifestosLocal(1)">
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
						<option value="100">100</option>
						<option value="200">200</option>
						<option value="1000">1000</option>
					</select>
					<span class="mr-sm-1">Registros</span>
				</div>
			</nav>

			<table class="table table-sm table-hover table-12">
				<thead>
					<tr>
						<th class="text-center">ID</th>
						<th>Nombre</th>
						<th class="text-center">Trasporte</th>
						<th class="text-center">Fecha de Creación</th>
						<th class="text-center">Ultima Actualización</th>
						<th>Descripción</th>
						<th class="text-center">Envíos Relacionados</th>
						<th class="text-center">Estado</th>
						<th class="text-right">
							<button class="fas fa-plus-circle" :class="(!newManifesto) ? 'text-primary pointer' : 'text-muted'" @click="addRowListManifestosLocal" :disabled="newManifesto"></button>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="newManifesto">
						<td class="text-center" :title="objectManifesto.id">-</td>
						<td>
							<input class="input-default" type="text" v-model="objectManifesto.name"/>
						</td>
						<td class="text-center">
							<select v-model="objectManifesto.transport_id" :disabled="searchingTransport">
								<option v-if="searchingTransport" value="0">Buscando transportes...</option>
								<option v-for="(item, index) in listTransportsFilter" :key="index" :value="item.id">{{ item.name }}</option>
							</select>
						</td>
						<td>-</td>
						<td>-</td>
						<td>
							<input class="input-default" type="text" v-model="objectManifesto.description"/>
						</td>
						<td class="text-center">0</td>
						<td class="text-center text-muted">Creando</td>
						<td class="text-right">
							<i class="far fa-save text-primary pointer" title="Guardar nuevo manifiesto" @click="saveManifestoLocal"></i>
						</td>
					</tr>
					<tr v-for="(item, index) in listManifestos" :key="index">
						<td class="text-center align-middle"><span @dblclick="viewAllItem(item)">{{ item.id }}</span></td>
						<td class="align-middle">{{ item.name }}</td>
						<td class="text-center align-middle" :class="'text-' + item.transport.color">{{ item.transport.name }}</td>
						<td class="text-center align-middle">{{ item.created_at }}</td>
						<td class="text-center align-middle">{{ item.updated_at }}</td>
						<td class="align-middle">{{ item.description }}</td>
						<td class="text-center align-middle">{{ item.shippings.length }}</td>
						<td class="text-center align-middle" :class="'text-' + item.status.color">
							<div class="custom-control custom-switch text-center" v-if="item.status_id < 28 && item.id > 0" >
								<input type="checkbox" class="custom-control-input" :id="'customSwitchStatusManifesto' + item.id" v-model="item.opened" @click="changeStatusManifesto(item)">
								<label class="custom-control-label" :for="'customSwitchStatusManifesto' + item.id"></label>
							</div>
							<span v-else>
								{{ item.status.name }}
							</span>
						</td>
						<td class="text-right align-middle">
							<i class="far fa-eye margin-right5 text-info pointer" @click="showManifestoModal(item.id)"></i>
							<i class="far fa-file-pdf margin-right5 text-danger pointer" v-if="item.status_id > 26" @click="showGeneratePDFManifestoModal(item.id)"></i>
							<i class="fas fa-dolly margin-right5 text-success margin-right5" v-if="item.status_id == 27" @click="markAsDispatched(item)"></i>

						</td>
					</tr>
				</tbody>
			</table>
			<pagination :pagination="paginationManifestos" @getAllList="getAllManifestosLocal"></pagination>

			<!-- Modal Generar Manifiesto-->
			<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#dataGeneratePDFManifestoModal" ref="btnShowDataGeneratePDFManifestoModal" v-show="false">Abrir Transportistas</button>
			<div class="modal fade" id="dataGeneratePDFManifestoModal" tabindex="-2" aria-labelledby="dataGeneratePDFManifestoModalLabel" aria-hidden="true">
				<div class="modal-dialog">
					<div class="modal-content">
						<form :action="urlShowManifesto(manifestoIDSelected) + '/pdf'" method="GET">
							<div class="modal-body">
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Coordinador</label>
									<div class="col-sm-9">
										<select class="form-control form-control-sm" name="coordinator" v-model="localStorageManifesto.coordinator" @change="setLocalStorageManifesto()">
											<option v-for="(item, index) in listEmployeesFilter" :key="index" :value="item.name + ' ' + item.surname">{{ item.name + ' ' + item.surname}}</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Conductor</label>
									<div class="col-sm-9">
										<select class="form-control form-control-sm" name="driver" v-model="localStorageManifesto.driver" @change="setLocalStorageManifesto()">
											<option v-for="(item, index) in listEmployeesFilter" :key="index" :value="item.name + ' ' + item.surname">{{ item.name + ' ' + item.surname}}</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="inputPassword" class="col-sm-3 col-form-label">Responsable</label>
									<div class="col-sm-9">
										<select class="form-control form-control-sm" name="responsable" v-model="localStorageManifesto.responsable" @change="setLocalStorageManifesto()">
											<option v-for="(item, index) in listEmployeesFilter" :key="index" :value="item.name + ' ' + item.surname">{{ item.name + ' ' + item.surname}}</option>
										</select>
									</div>
								</div>
							</div>
							<div class="modal-footer">
								<input  type="submit" class="btn btn-primary btn-sm" value="Generar PDF"/>
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" aria-label="Close">Cerrar</button>
							</div>
						</form>
					</div>
				</div>
			</div>

			<!-- Modal Manifiesto Component-->
			<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#manifestoComponentModal" ref="btnShowManifestoComponentModal" v-show="false">Abrir Manifiestos</button>
			<div class="modal fade" id="manifestoComponentModal" tabindex="-2" aria-labelledby="manifestoComponentModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-xl">
					<div class="modal-content">
						<div class="modal-body">
							<manifesto-component
								ref="manifestoComponent"
								:id="manifestoIDSelected">
							</manifesto-component>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" aria-label="Close">Cerrar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="text-center">
			Buscando Manifiestos . . .
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import manifesto from '@/mixins/manifestos'
	import transport from '@/mixins/transports'
	import employees from '@/mixins/employees'

	import Pagination from '@/components/Pagination.vue'
	import ManifestoComponent from '@/components/ManifestoComponent.vue'

	export default {
		name: 'ListManifestosComponent',
		mixins: [axiosAction, errors, mixin, manifesto, transport, employees],
		props: ['showManifestoLocal'],
		data() {
			return {
				manifestoIDSelected: 0,
				newManifesto: false,
			}
		},
		components: {
			'pagination': Pagination,
			'manifesto-component': ManifestoComponent,
		},
		computed: {
			listEmployeesFilter() {
				let list = this.listEmployees
				return list
			},
			listManifestosFilter() {
				let list = this.listManifestos
				return list
			},
			listTransportsFilter() {
				let list = this.listTransports
				return list
			},
		},
		methods: {
			changeStatusManifesto(item) {
				let trackingsManifestoId = (!item.opened) ? 2 : 4
				this.addManifestoTrackingsManifesto(item.id, trackingsManifestoId)
			},
			addRowListManifestosLocal() {
				this.clearObjectManifesto()
				this.newManifesto = true
			},
			initComponentLocal(){
				this.fromDateManifestos = this.currentDate(-15)
				this.toDateManifestos = this.currentDate()
				this.getAllTransports()
				this.getEmployeesByDepartament(6)
			},
			getAllEmployeesResultLocal(response) {
				this.getLocalStorageManifesto()
			},
			getAllManifestosLocal(page = 1) {
				this.newManifesto = false
				this.getAllManifestos(page)
			},
			getAllManifestosResultLocal(response) {},
			getAllTransportsResultLocal(response) {},
			markAsDispatched(manifesto) {
				if(confirm('El estado del manifiesto ' + manifesto.name + '(' + manifesto.id + ') quedará como despachado, no se podra volver a atras\n¿Deseas continuar?')) {
					this.addManifestoTrackingsManifesto(manifesto.id, 6)
				}
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'addManifestoTrackingsManifestoResult': this.addManifestoTrackingsManifestoResult(response); break;
					case 'getAllEmployeesResult': this.getAllEmployeesResult(response); break;
					case 'getAllManifestosResult': this.getAllManifestosResult(response); break;
					case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
					case 'saveManifestoResult': this.saveManifestoResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			saveManifestoLocal() {
				if(this.objectManifesto.transport_id > 0 && this.objectManifesto.name.trim() != "") {
					this.saveManifesto()
				} else {
					this.$snotify.warning('Tienes que llenar todos los datos', 'Falta Datos')
				}
			},
			saveManifestoResultLocal(response) {
				if(response.data.success == true) {
					this.$emit('actionSaveManifesto', response.data.data)
					this.newManifesto = false
				}
			},
			showGeneratePDFManifestoModal(id) {
				this.manifestoIDSelected = id
				setTimeout(()=>{
					this.$refs.btnShowDataGeneratePDFManifestoModal.click()
				}, 100)
			},
			showManifestoModal(id) {
				if(this.showManifestoLocal == true) {
					this.manifestoIDSelected = id
					setTimeout(()=>{
						this.$refs.manifestoComponent.$refs.btnShowManifesto.click()
						this.$refs.btnShowManifestoComponentModal.click()
					}, 100)
				} else {
					this.$emit('actionShowManifesto', id)
				}
			},
			showManifestoResultLocal(response) {
				if(response.data.success == true) {
					console.log(this.objectManifesto)
				}
			},
			updateStatusManifestoLocal(manifestoTrackingManifesto) {
				let index = this.listManifestos.map(e => parseInt(e.id)).indexOf(parseInt(manifestoTrackingManifesto.manifesto_id))
				let manifesto = null
				if(index > -1) {
					manifesto = this.listManifestos[index]
				}
				this.$emit('actionUpdateManifesto', manifestoTrackingManifesto, manifesto)
			}
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
